import { useMemo } from 'react';

// context
import { AppContextProvider } from '@/components/utilities/AppContext';

// components
import Page404 from './Page404';
import Page500 from './Page500';
import PageHead from './PageHead';
import ComponentsRender from '@/components/ComponentsRender';
import ScrollSensor from '@/components/utilities/ScrollSensor';
import GlossaryDetailPage from '@/components/components/glossary/GlossaryDetailPage';

// constants
import { LAYOUT_BLOCKS } from '@/components/components';

const NAV_TYPENAMES = new Set(['ComponentLayoutBlocksNavigationBlock']);
const FOOTER_TYPENAMES = new Set(['ComponentLayoutBlocksFooterBlock']);

const Page = ({
  pageData,
  error,
  locale,
  rootPath,
  restOfPath,
  queryParams,
  isPreview,
  glossaryTerm = null,
  glossaryTerms = null
}) => {
  const appContext = useMemo(
    () => ({
      locale,
      rootPath,
      restOfPath,
      queryParams,
      glossaryTerm,
      glossaryTerms
    }),
    [locale, restOfPath, rootPath, queryParams, glossaryTerm, glossaryTerms]
  );

  if (error) {
    return <Page500 error={error} />;
  }

  if (!pageData) {
    return <Page404 />;
  }

  const { title, description, path, localizations } = pageData;
  const content = pageData.content || [];

  const isGlossaryDetail = Boolean(glossaryTerm);

  const headTitle = isGlossaryDetail ? glossaryTerm.title : title;
  const headDescription = isGlossaryDetail ? glossaryTerm.shortDescription : description;

  return (
    <>
      <PageHead
        title={headTitle}
        description={headDescription}
        path={path}
        locale={locale}
        localizations={localizations}
        isPreview={isPreview}
      />

      <AppContextProvider value={appContext}>
        <ScrollSensor>
          {isGlossaryDetail ? (
            <>
              {content
                .filter((component) => NAV_TYPENAMES.has(component.__typename))
                .map((component) => (
                  <ComponentsRender
                    key={`${component.id}_${component.__typename}`}
                    type={LAYOUT_BLOCKS}
                    component={component}
                  />
                ))}

              <GlossaryDetailPage />

              {content
                .filter((component) => FOOTER_TYPENAMES.has(component.__typename))
                .map((component) => (
                  <ComponentsRender
                    key={`${component.id}_${component.__typename}`}
                    type={LAYOUT_BLOCKS}
                    component={component}
                  />
                ))}
            </>
          ) : (
            content.map((component) => (
              <ComponentsRender
                key={`${component.id}_${component.__typename}`}
                type={LAYOUT_BLOCKS}
                component={component}
              />
            ))
          )}
        </ScrollSensor>
      </AppContextProvider>
    </>
  );
};
export default Page;
